import { Component, OnInit, Input, OnDestroy, Self } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl } from '@angular/forms';

import { mergeMap, map, startWith } from 'rxjs/operators';

import { interfaces } from '@leandredev/dcbm-common-lib';
import { AutoCompleteComponent, StatesService, UIComponentState, ObjectId, ApiHelper } from '@leandredev/common_ng_14';

import { ApiService } from 'src/app/services/api/api.service';

@Component({
  selector: 'app-acttype-form-auto-complete',
  templateUrl: './ActType.component.html',
  styleUrls: ['./ActType.component.scss'],
  providers: [UIComponentState]
})
export class ActTypeFormAutoCompleteComponent extends AutoCompleteComponent<interfaces.IActType> implements OnInit, OnDestroy {
  @Input()
  public get hasOverridedData(): boolean {
    return this._hasOverridedData;
  }

  public set hasOverridedData(value: boolean) {
    this._hasOverridedData = value;

    if (!value) return;

    this.unsubscribePformCtrl();

    if (this.overridedData) this.filteredData = this.overridedData;
  }

  private _hasOverridedData = false;

  @Input()
  public get overridedData(): interfaces.IActType[] {
    return this._overridedData;
  }

  public set overridedData(value: interfaces.IActType[]) {
    this._overridedData = value;

    if (!value || !this.hasOverridedData) return;

    this.filteredData = value;
  }

  private _overridedData: interfaces.IActType[] = [];

  constructor(
    @Self() public uIComponentState: UIComponentState,
    public statesService: StatesService,
    protected activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService
  ) {
    super(uIComponentState, statesService);

    this.httpServiceBase = apiService.collections.ActType;

    if (this.hasOverridedData) return;

    this.pformCtrlSub = this._formCtrl.valueChanges
      .pipe(
        startWith(null),
        mergeMap((value) => {
          if (typeof value === 'string') {
            if (value) {
              value = value.trim();
            }
            if (value) {
              return this.httpServiceBase.get(`name/${value}/i/$regex/10/$limit/`);
            } else {
              return this.httpServiceBase.get(`*/10/$limit/`);
            }
          } else {
            return this.httpServiceBase.get(`*/10/$limit/`);
          }
        }),
        map((result) => {
          if (!this.pformCtrlSub) {
            return;
          }
          if (this.hasOverridedData) {
            this.unsubscribePformCtrl();
            this.filteredData = this.overridedData;
            return;
          }
          this.filteredData = result.response as interfaces.IActType[];
        })
      )
      .subscribe();
  }

  public ngOnInit(): void {
    this.initDataState();
    this.checkSateExchange();
  }

  private unsubscribePformCtrl(): void {
    if (!this.pformCtrlSub) {
      return;
    }
    this.pformCtrlSub.unsubscribe();
    // delete this.pformCtrlSub;
  }

  public addNewItem(): void {
    // attention si formCtrlrray
    let currSelect: any;
    if (this.formCtrl) {
      currSelect = [this.formCtrl.value];
    }

    if (this.formArr) {
      currSelect = this.formArr.value;
    }
    this.statesService.navigate([`ActType/new/` + ObjectId.stringObjectId()], { relativeTo: this.activatedRoute.parent }, this.id + '/new', {
      currentSelection: currSelect
    });
  }

  protected initDataState(): void {
    this.subscription.add(
      this.activatedRoute.data.subscribe((dataState) => {
        if (!dataState || !dataState.state) {
          return;
        }
        this.initState(dataState.state);
      })
    );
  }

  protected initState(state: any): void {
    this.uIComponentState.addToState(state);
    this.uIComponentState.id = this.id;
    Object.assign(this.state, this.uIComponentState.state);
    Object.assign(this.uIComponentState.state, this.state);
    this.state = this.uIComponentState.state;
  }

  public editClassItem(obj: interfaces.IActType): void {
    const urlforEdit = `/data/${obj._class}/edit/${obj._id}`;
    void this.router.navigate([urlforEdit]);
  }

  // Lorsqu'un nouvel élément a été échangé avec la page précédente, on met à jour la configuration du formulaire.
  protected checkSateExchange(): void {
    const currentState = this.statesService.getCurrentState();

    if (currentState.exchange?.command) {
      const index = currentState.exchange?.command.indexOf('/');

      if (index > -1) {
        const prop = currentState.exchange?.command.slice(0, index);

        if (prop === this.id) {
          this.httpServiceBase
            .get(currentState.exchange.data.currentSelection[0])
            .pipe(ApiHelper.resultToArrWEmptyError('new item in state not found'))
            .subscribe((result) => {
              if (this.formCtrl) {
                this.formCtrl.patchValue(currentState.exchange.data.currentSelection[0]);
                this.populatedValue = result;
              }

              if (this.formArr) {
                const newCtrl = new FormControl();
                newCtrl.patchValue(currentState.exchange.data.currentSelection[0]);
                this.formArr.controls.push(newCtrl);
                this.formArr.value.push(currentState.exchange.data.currentSelection[0]);

                this.populatedValue.push(result[0]);
              }

              currentState.exchange = null;
              currentState.prevExchange = null;
            });
        }
      }
    }
  }
}
